/**
 * 关卡模块静态注册表：替代原先 `import(`../content/stages/stage${idx+1}.js`)`
 * 的模板串动态加载——模板串无法被 bundler 静态分析（treeshake 会丢、打包后 404），
 * 且 7 个关卡总共 ~900 行，全量静态引入代价可忽略，还消掉装载异步等待。
 */
import stage1 from './stage1.js';
import stage2 from './stage2.js';
import stage3 from './stage3.js';
import stage4 from './stage4.js';
import stage5 from './stage5.js';
import stage6 from './stage6.js';
import stageExtra from './stageExtra.js';

/** 按 stageIndex（0-5）取普通关；Extra 关单列。 */
export const STAGE_MODULES = [stage1, stage2, stage3, stage4, stage5, stage6];
export { stageExtra };
